/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ShareTargetForSavingsPlan extends models.ShareTarget {
    constructor() {
        super();
        this.setDiscriminator("ShareTargetForSavingsPlan");
    }

    getFixupPrototypeFunction() { return ShareTargetForSavingsPlan.fixupPrototype; }

    static newInstance(model: Partial<ShareTargetForSavingsPlan>): ShareTargetForSavingsPlan {
        let obj = Object.assign(new ShareTargetForSavingsPlan(), model);
        ShareTargetForSavingsPlan.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ShareTargetForSavingsPlan>): ShareTargetForSavingsPlan {
        if (!model) return null;
        return ShareTargetForSavingsPlan.newInstance(<ShareTargetForSavingsPlan> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ShareTargetForSavingsPlan) {
        if (!obj) return;

        models.ShareTargetForSavingsPlan.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ShareTargetForSavingsPlan): boolean {
        if (models.ShareTarget.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ShareTargetForSavingsPlan.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
